import {
  Component,
  DOCUMENT,
  Inject,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { HeroComponent } from './hero/hero.component';
import { NavbarControlComponent } from '../shared/controls/navbar-control/navbar-control.component';
import { FooterComponent } from '../shared/controls/footer/footer.component';
import { loadComponentTranslations } from '../shared/funcs/lang-loader';
import { isPlatformBrowser } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { ContactSectionComponent } from '../shared/controls/contact-section/contact-section.component';
import { BeautySalonBookingChallengesComponent } from './beauty-salon-booking-challenges/beauty-salon-booking-challenges.component';
import { BeautySalonBookingWorkflowComponent } from './beauty-salon-booking-workflow/beauty-salon-booking-workflow.component';

@Component({
  selector: 'app-beauty-salon-booking',
  imports: [
    HeroComponent,
    NavbarControlComponent,
    FooterComponent,
    BeautySalonBookingChallengesComponent,
    BeautySalonBookingWorkflowComponent,
    ContactSectionComponent,
  ],
  templateUrl: './beauty-salon-booking.component.html',
  styleUrl: './beauty-salon-booking.component.scss',
})
export class BeautySalonBookingComponent implements OnInit {
  public selectedLanguage: string = 'en';

  private isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,

    private _http: HttpClient,
    private _translateService: TranslateService,
    @Inject(DOCUMENT) private document: Document,
    private metaService: Meta,
    private titleService: Title,
  ) {}

  public ngOnInit(): void {
    const pageUrl = 'https://clockflex.com/beauty-salon-booking';
    console.log('Beauty Salon Booking Page URL:', pageUrl);
    this.titleService.setTitle('Beauty Salon Booking Software | ClockFlex');

    this.setCanonicalUrl(pageUrl);

    this.metaService.updateTag({
      name: 'description',
      content:
        'Manage salon appointments, spa bookings, beauty services, and staff schedules with ClockFlex. Let clients book hair, skincare, and makeup services online.',
    });

    // Open Graph
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Beauty Salon Booking Software | ClockFlex',
    });

    this.metaService.updateTag({
      property: 'og:description',
      content:
        'Simplify bookings for salons, spas, makeup artists, and beauty professionals. Manage services, staff availability, and client appointments with ClockFlex.',
    });

    this.metaService.updateTag({
      property: 'og:url',
      content: pageUrl,
    });

    this.metaService.updateTag({
      property: 'og:type',
      content: 'website',
    });

    this.metaService.updateTag({
      property: 'og:image',
      content: 'https://clockflex.com/assets/images/beauty-salon-og-image.png',
    });

    // Twitter / X
    this.metaService.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });

    this.metaService.updateTag({
      name: 'twitter:title',
      content: 'Beauty Salon Booking Software | ClockFlex',
    });

    this.metaService.updateTag({
      name: 'twitter:description',
      content:
        'Manage beauty appointments, spa treatments, makeup bookings, and staff schedules with ClockFlex.',
    });

    this.metaService.updateTag({
      name: 'twitter:image',
      content: 'https://clockflex.com/assets/images/beauty-salon-og-image.png',
    });
    // ✅ Language (SSR-safe default)
    this.selectedLanguage = 'en';

    if (this.isBrowser()) {
      this.selectedLanguage = localStorage.getItem('language') || 'en';
    }

    loadComponentTranslations(
      this._http,
      this._translateService,
      'components/beauty-salon-booking',
      this.isBrowser(),
    ).subscribe({
      next: () => {},
      error: () => {},
    });
  }

  private setCanonicalUrl(url: string): void {
    if (!url.startsWith('http')) {
      return; // safety guard
    }

    let link: HTMLLinkElement | null = this.document.querySelector(
      "link[rel='canonical']",
    );

    if (!link) {
      link = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.document.head.appendChild(link);
    }

    link.setAttribute('href', url);
  }
}
